import {useLayoutEffect, RefObject} from 'react';
import {useThemeValue} from '@gravity-ui/uikit';

interface IframeThemeOptions {
    containerRef: RefObject<HTMLElement>;
}

export function useIframeTheme(options: IframeThemeOptions) {
    const {containerRef} = options;
    const themeValue = useThemeValue();
    const element = containerRef.current;

    useLayoutEffect(() => {
        const iframesInside = element?.querySelectorAll('iframe');

        iframesInside?.forEach((iframe) => {
            if (!iframe.contentWindow) {
                return;
            }

            const iframeSrc = iframe.getAttribute('src');

            if (!iframeSrc) {
                return;
            }

            try {
                const url = new URL(iframeSrc);

                if (!themeValue) {
                    return;
                }

                url.searchParams.set('_theme', themeValue);
                const srcWithTheme = String(url);

                if (iframeSrc !== srcWithTheme) {
                    iframe.setAttribute('src', srcWithTheme);
                }
            } catch (error) {
                console.error('Failed to parse iframe src', error);
            }
        });
    }, [element, themeValue]);
}
